<template>
  <div class="row">
    <div class="col-12">
      <m-input
        class="search-form-field"
        v-model="search.PAYTYPENAME"
        nolabel
        :placeholder="$t('search.paymenttypename')"
      ></m-input>
    </div>
  </div>
</template>

<script>
import api from "../../api";
export default {
  data() {
    return {
      search: {
        PAYTYPENAME: null,
      },
    };
  },

  methods: {
    getSearch() {
      return this.search;
    },
    clearSearch() {
      this.search = {
        PAYTYPENAME: null,
      };
    },
  },
};
</script>

<style></style>
